import React from 'react';
import {connector, DefaultLayout} from '@src/components/_layouts/Default/DefaultLayout';
import {LayoutContext} from '@src/contexts/LayoutContext';
import ContentBlock from '@src/components/_layouts/Default/components/content/ContentBlock';
import Footer from '@src/components/_layouts/Default/components/Footer';
import Loader from '@views/dashboard/production/SimpleLayout/Loader';

const contentContainerStyles = {
    '--header-height': '0px',
    marginLeft: 0,
} as React.CSSProperties;

const footerStyles: React.CSSProperties = {left: 0};

export class SimpleLayout extends DefaultLayout {
    render() {
        return <LayoutContext.Provider value={this.layoutContextApi}>
            <Loader/>

            <ContentBlock
                    footerRef={this.footerRef}
                    headerRef={this.headerRef}
                    containerStyle={contentContainerStyles}
            >{this.renderContent()}</ContentBlock>

            <Footer footerRef={this.footerRef} style={footerStyles}/>
        </LayoutContext.Provider>;
    }
}

export default connector(SimpleLayout);
